<template>
	<div class="">
		<header-vue></header-vue>
		<div class="container-l2 overHidden">
			<div class="orderTop clearfloat">
				<ul>
					<li>问题标题：<span v-text="worder.title"></span></li>
					<li>案例严重性：<span v-text="forUrgent2(worder.urgent)"></span></li>
					<li>工单编号：<span v-text="worder.order"></span></li>
				</ul>
				<ul v-if="administrators==3">
					<li>提交人昵称：<span v-text="worder.user_name"></span></li>
					<li>受理人：<span v-text="worder.emp_name"></span></li>
					<li>工单类别：<span v-text="worder.caption"></span></li>
					
				</ul>
				<ul>
					<li>提交账号：<span v-text="worder.username"></span></li>
					<li>提交时间：<span v-text="dateFormat2(worder.created_time)"></span></li>
					<li>状态：
						<span class="green" v-if="administrators==3 || administrators==5" v-text="worder.description"></span>
						<span class="green" v-if="administrators!=3 && administrators!=5" v-text="worder.ustate"></span>
					</li>
				</ul>				
				<!-- 按钮组分情况 -->
				<div v-if="uid==this.worder.user_id"  class="deleteOrder">
					<span v-if="state=='7' || state=='8'" @click="showDelete()">删除工单</span>
					<span v-if="state!='7' && state!='8'" @click="closeFlag=true">确认结单</span>
				</div>				
				<div v-if="administrators==3 || administrators==5" class="deleteOrder">
					<span v-if="state!='7' && state!='8'" @click="closeFlag=true">确认结单</span>
					<span v-if="state=='1' || state=='2'  || state=='4'" @click="showDispatch()">派单</span>					
				</div>
				<div v-if="administrators==4" class="deleteOrder">
					<span v-if="state=='3'" @click="acceptFlag=true">处理派单</span>					
				</div>
				
			</div>
			<div v-if="administrators==3 || administrators==5" class="contactList clearfloat">
				<h3>流转信息</h3>
				<div class="repairBox">
					<div class="switchInfo" v-for="(item,index) in switchInfo" :key="index">
						<p class="time" v-text="dateFormat2(item.time)"></p>
						<p>{{item.senduser_name}}：{{item.forward}}</p>
						
					</div>
					

				</div>

					
			</div>
			<div class="contactList clearfloat">
				<h3>沟通记录</h3>
				<div class="contactDetail">
					<div :class="{
						'detail-left detail-right':item.administrators==1 || item.administrators==2,
						'detail-left':item.administrators==3 || item.administrators==4 || item.administrators==5
						}"
						 v-for="(item,index) in contactInfo" :key="index">
						 <div class="detail-time" v-text="dateFormat2(item.time)"></div>
						 <!-- 技术头像 -->
						 <span class="fl" v-if="item.administrators==3 || item.administrators==4 || item.administrators==5">
							 <img :src="$store.state.domain3+'logo2.png'" alt="">
						 </span>
						 <!-- 客户头像 -->
						 <span class="fr" v-if="item.administrators==1 || item.administrators==2">
							 <img src="../../images/client.png" alt="">
						 </span>
						<div class="contactCon">
							<p v-text="item.feedback"></p>
							<div class="conPath" v-if="item.path!=''">
								<a class="el-button el-button--text el-button--small" target="_blank" v-for="(item,index) in formatPath(item.path)" :key="index" :href="item.url">附件</a>
							</div>
						</div>
						
					</div>
					
				</div>
			</div>
			<div v-if="state=='7'" class="contactList clearfloat">
				<h3>待您评价</h3>
				<el-form class="repairBox" ref="evaluation" label-width="120px" :model="evaluation">
					<el-form-item label="整体评价："
					prop="star"
					:rules="{
						required: true, message: '评价不能为空', trigger: 'change'
						}"
					>
						<el-rate
							v-model="evaluation.star"
							:colors="colors">
						</el-rate>
					</el-form-item>
					<el-form-item label="问题是否解决："
					prop="is_solve">
						<el-radio-group v-model="evaluation.is_solve">
							<el-radio label="Y">已解决</el-radio>
							<el-radio label="N">未解决</el-radio>
						</el-radio-group>
					</el-form-item>	

					<el-form-item label="我要反馈：" prop="appraise">
						<el-input type="textarea" v-model="evaluation.appraise"></el-input>
					</el-form-item>

					<el-form-item class="text-left">
						<el-button type="primary" @click="commandOrder(evaluation)">提交</el-button>
					</el-form-item>
					
				</el-form>
			</div>
			<div v-if="state!='7' && state!='8'" class="contactList clearfloat">
				<h3>我要反馈</h3>
				<el-form class="repairBox" ref="feedItem" label-width="120px" :model="feedItem">
					
					<el-form-item label="留言：" prop="feedback"
					:rules="{
						required: true, message: '留言不能为空', trigger: 'blur'
						}">
						<el-input type="textarea" v-model="feedItem.feedback"></el-input>
					</el-form-item>
					<el-form-item label="上传附件：">
				
						<el-upload
							:action='picUrl'
							ref='upload'
							:limit="imgLimit"
							:file-list="productImgs"
							:on-preview="handlePictureCardPreview"
							:on-remove="handleRemove"
							:on-success="handleAvatarSuccess"
							:before-upload="beforeAvatarUpload"
							:on-exceed="handleExceed"
							:on-error="imgUploadError">
							<el-button size="small" type="primary">上传附件</el-button>
						</el-upload>
					</el-form-item>

					<el-form-item class="text-left">
						<el-button type="primary" @click="sendFeedback(feedItem)">提交</el-button>
					</el-form-item>
					
				</el-form>
			</div>
		</div>
		<!--删除-->
		<el-dialog title="提示：" :visible.sync="removeFlag" width="500px" >
		    <div class="userInfo">
				<p>删除后，您将无法恢复和查看该工单，请谨慎操作<br/>
					您确认要删除该工单吗？</p>
			</div>
			  <div slot="footer" class="dialog-footer">
			    <el-button @click="removeFlag = false">取消</el-button>
			    <el-button type="primary" @click="deleteOrder()">确认</el-button>
			  </div>
		</el-dialog>
		<!--结单-->
		<el-dialog title="提示：" :visible.sync="closeFlag" width="500px" >
		    <div class="userInfo">
				<p>当您确认工单问题已经得到解决，您可以结束工单。结束工单后如果有新的问题，您可以提交新的工单咨询。</p>
			</div>
			  <div slot="footer" class="dialog-footer">
			    <el-button @click="closeFlag = false">取消</el-button>
			    <el-button type="primary" @click="changeState('7')">确认</el-button>
			  </div>
		</el-dialog>
		<!--派单弹框-->
		<el-dialog title="提示：" :visible.sync="dispatchFlag" width="500px" >
		    <div class="userInfo">
				<el-select class="ml20" v-model="emp_id" placeholder="请选择派单人员">
					<el-option v-for="(item,index) in disUsers" :key="index" :label="item.real_name" :value="item.uid"></el-option>
				</el-select>
			</div>
			  <div slot="footer" class="dialog-footer">
			    <el-button @click="dispatchFlag = false">取消</el-button>
			    <el-button type="primary" @click="changeState(3)">确认</el-button>
			  </div>
		</el-dialog>
		<!--受理人是否接受派单-->
		<el-dialog title="派单处理：" :visible.sync="acceptFlag" width="500px" >
		    <div class="userInfo">
				<el-form>
					<el-form-item label="是否接单：">
						<el-radio-group v-model="ifAccept">
							<el-radio label="5">是</el-radio>
							<el-radio label="4">否</el-radio>
						</el-radio-group>
					</el-form-item>
					<el-form-item label="备注：">
						<el-input type="textarea" v-model="opinion"></el-input>
					</el-form-item>
				</el-form>
								
			</div>
			  <div slot="footer" class="dialog-footer">
			    <el-button @click="acceptFlag = false">取消</el-button>
			    <el-button type="primary" @click="changeState(ifAccept)">确认</el-button>
			  </div>
		</el-dialog>
	</div>
</template>
<script>
export default {
  name: 'app',
  data(){
    return {
		worder:{},
		contactInfo:[],
		state:"",
		removeFlag:false,
		administrators:this.getCookie("administrators"),
		closeFlag:false,
		colors: ['#99A9BF', '#F7BA2A', '#FF9900'],
		evaluation:{},
		productImgs: [],
		imgLimit: 5,
		picUrl: this.$store.state.domain2+"/admin/Wordermanage/uploadfile",
		feedItem:{},
		uid:this.getCookie('uid'),
		dispatchFlag:false,
		// 派单人员列表
		disUsers:[],
		emp_id:null,
		opinion:"",
		acceptFlag:false,
		ifAccept:null,
		switchInfo:[]
    }
  },
  mounted(){
    this.$nextTick(function(){
		// 获取派单人员列表
		this.getDisuser();
		this.getDetail();
		this.getSwitchInfo();
  	})
  },

  methods: {
	getDetail(){
		let valiCodeParams={
			uid:this.getCookie('uid'),
			id:this.$route.query.id,
			token:this.getCookie('token'),
			time:Date.parse( new Date()),
			terminalId:4
		};
		
		this.sign2(valiCodeParams);
		this.$ajax.post(this.$store.state.domain2+"/admin/Wordermanage/detail",this.$qs.stringify(valiCodeParams),{
			emulateJSON: true
		}).then(res=>{
			if(res.data.code=="200"){
				this.worder = res.data.data.worder || {};
				this.state = res.data.data.worder.state || "";
				this.contactInfo = res.data.data.feedback || [];
				
				
			}else if(res.data.code==10008){
				this.delCookie('username');
				this.$router.push('/login/');
				this.$store.commit('updateUserInfo', this.$store.state.originalUserInfo); 
			}else{
				this.$message.error(res.data.msg);
			}
		});
	},
	// 获取流转单信息
	getSwitchInfo(){
		let valiCodeParams={
			uid:this.getCookie('uid'),
			id:this.$route.query.id,
			token:this.getCookie('token'),
			time:Date.parse( new Date()),
			terminalId:4
		};
		
		this.sign2(valiCodeParams);
		this.$ajax.post(this.$store.state.domain2+"/admin/Wordermanage/worderroam",this.$qs.stringify(valiCodeParams),{
			emulateJSON: true
		}).then(res=>{
			if(res.data.code=="200"){
				this.switchInfo = res.data.data || [];			
				
			}else if(res.data.code==10008){
				this.delCookie('username');
				this.$router.push('/login/');
				this.$store.commit('updateUserInfo', this.$store.state.originalUserInfo); 
			}else{
				this.$message.error(res.data.msg);
			}
		});
	},
	getDisuser(){
		let setNewPassParams={
			uid:this.getCookie('uid'),
			role_id:'4',
			company_id:this.getCookie('company_id'),
			token:this.getCookie('token'),
			time:Date.parse( new Date()),
			terminalId:4
		};
		this.sign2(setNewPassParams);
		this.$ajax.post(this.$store.state.domain2+'/admin/Role/roleuserlist',this.$qs.stringify(setNewPassParams),{
			emulateJSON: true
		}).then(res=>{
			if(res.data.code=="200"){
				this.disUsers = res.data.data || [];
			}else if(res.data.code==10008){
				this.delCookie('username');
				this.$router.push('/login/');
				this.$store.commit('updateUserInfo', this.$store.state.originalUserInfo); 
			}else{
				this.$message.error(res.data.msg);
			}
		});
	},
	showDispatch(){
		this.dispatchFlag = true;
	},
	
	showDelete(){
		this.removeFlag = true;		
	},	
	commandOrder(evaluation){
				
		this.$refs.evaluation.validate((valid) => {
			if (valid) {
				let setNewPassParams={
					uid:this.getCookie('uid'),
					id:this.worder.id,
					star: this.evaluation.star || "",
					appraise: this.evaluation.appraise || "",
					is_solve: this.evaluation.is_solve || "",
					token:this.getCookie('token'),
					time:Date.parse( new Date()),
					terminalId:4
				};
				this.sign2(setNewPassParams);
				this.$ajax.post(this.$store.state.domain2+'/admin/Wordermanage/appraise',this.$qs.stringify(setNewPassParams),{
					emulateJSON: true
				}).then(res=>{
					if(res.data.code=="200"){
						this.getDetail();
						this.$message.success(res.data.msg);
					}else if(res.data.code==10008){
						this.delCookie('username');
						this.$router.push('/login/');
						this.$store.commit('updateUserInfo', this.$store.state.originalUserInfo); 
					}else{
						this.$message.error(res.data.msg);
					}
				});
			} else {
				console.log('error submit!!');
				return false;
			}
		});
		
		
	},
	// 确认结单、派单、拒单
	changeState(state){
		if(state==4 || state ==5){
			this.emp_id = this.getCookie('uid');
		}
		let valiCodeParams={
			uid:this.getCookie('uid'),
			id:this.worder.id,
			state:state,
			opinion:this.opinion || "",
			emp_id:this.emp_id || "",
			token:this.getCookie('token'),
			time:Date.parse( new Date()),
			terminalId:4
		};
		
		this.sign2(valiCodeParams);
		this.$ajax.post(this.$store.state.domain2+"/admin/Wordermanage/updatestate",this.$qs.stringify(valiCodeParams),{
			emulateJSON: true
		}).then(res=>{
			if(res.data.code=="200"){
				this.dispatchFlag = false;
				this.closeFlag = false;
				this.acceptFlag = false;
				this.$message.success(res.data.msg);
				this.getDetail();
			}else if(res.data.code==10008){
				this.delCookie('username');
				this.$router.push('/login/');
				this.$store.commit('updateUserInfo', this.$store.state.originalUserInfo); 
			}else{
				this.$message.error(res.data.msg);
			}
		});
	},
	formatPath(path){
		if(path && path!=""){
			var productImgs = [];
			var imageList = path.split(',')
			for(var i=0;i<imageList.length;i++){
				
				productImgs.push(
					{
						name:imageList[i].replace(/(.*\/)*([^.]+).*/ig,"$2") + "." + imageList[i].replace(/.+\./,""),
						url:this.$store.state.domain2+imageList[i]
					}
				);
			}
			return productImgs;
				
		}
	},
	deleteOrder(){
		let valiCodeParams={
			uid:this.getCookie('uid'),
			id:this.worder.id,
			token:this.getCookie('token'),
			time:Date.parse( new Date()),
			terminalId:4
		};
		
		this.sign2(valiCodeParams);
		this.$ajax.post(this.$store.state.domain2+"/admin/Wordermanage/del",this.$qs.stringify(valiCodeParams),{
			emulateJSON: true
		}).then(res=>{
			if(res.data.code=="200"){
				this.removeFlag = false;
				this.$router.push("/repairOrderPub")
				
			}else if(res.data.code==10008){
				this.delCookie('username');
				this.$router.push('/login/');
				this.$store.commit('updateUserInfo', this.$store.state.originalUserInfo);  
			}else{
				this.$message.error(res.data.msg);
			}
		});
	},
	sendFeedback(feedItem){
		this.$refs.feedItem.validate((valid) => {
			if (valid) {
				let setNewPassParams={
					uid:this.getCookie('uid'),
					id:this.worder.id,								
					feedback:this.feedItem.feedback || "",
					path:this.feedItem.path || "",
					token:this.getCookie('token'),
					time:Date.parse( new Date()),
					terminalId:4
				};
				this.sign2(setNewPassParams);
				this.$ajax.post(this.$store.state.domain2+'/admin/Wordermanage/feedback',this.$qs.stringify(setNewPassParams),{
					emulateJSON: true
				}).then(res=>{
					if(res.data.code=="200"){
						this.feedItem = {}
						this.getDetail();
						// 提交反馈成功后清空文件列表
						this.productImgs = [];
						this.$message.success(res.data.msg);
					}else if(res.data.code==10008){
						this.delCookie('username');
						this.$router.push('/login/');
						this.$store.commit('updateUserInfo', this.$store.state.originalUserInfo); 
					}else{
						this.$message.error(res.data.msg);
					}
				});
			} else {
				console.log('error submit!!');
				return false;
			}
		});
	},
	// 多个文件
	handleRemove(file, fileList) {//移除图片
		var imageList = this.feedItem.path.split(',')
		let index = this.productImgs.indexOf(file);
		if(index!=-1){
			this.productImgs.splice(index,1);
			imageList.splice(index,1);
		}
		this.feedItem.path = imageList.join(',');
//		        console.log(file, fileList);
		// console.log(this.productImgs)
		
		
		},
		handlePictureCardPreview(file) {//预览图片时调用
//		        console.log(file);
		this.dialogImageUrl = file.url;
		this.dialogVisible = true;
		},
	
		beforeAvatarUpload(file) {//文件上传之前调用做一些拦截限制
		
		const isLt2M = file.size / 1024 / 1024 < 2;
				
		if (!isLt2M) {
			this.$message.error('上传图片大小不能超过 2MB!');
		}
		return isLt2M;
		},
//		      多个文件
		handleAvatarSuccess(res, file) {//上传成功
		// console.log(res,file,'upload--------');
		
		//地址赋值
		
		if(res.data.path && res.data.path!=""){
			if(this.feedItem.path=="" || !this.feedItem.path){
				this.feedItem.path = res.data.path;
			}else{
				this.feedItem.path = this.feedItem.path + ',' + res.data.path;
			}
			
		}
		if(this.feedItem.path && this.feedItem.path!=""){
			this.productImgs = [];
			var imageList = this.feedItem.path.split(',')
			for(var i=0;i<imageList.length;i++){
				
				this.productImgs.push(
					{
						name:imageList[i].replace(/(.*\/)*([^.]+).*/ig,"$2") + "." + imageList[i].replace(/.+\./,""),
						url:this.$store.state.domain+imageList[i]
					}
				);
			}
				
		}
		
		
		},
		handleExceed(files, fileList) {//图片上传超过数量限制
		this.$message.error('只能上传一张图片!');
//		        console.log(file, fileList);
		},
		imgUploadError(err, file, fileList){//图片上传失败调用
		console.log(err)
		this.$message.error('上传图片失败!');
		},
	
  }
}
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/rightPanel/repairDetail.vue